import {FormUlList, TabFormSection, TabsSection} from "./Styled";
import React from "react";
import CountryField from "./Fields/CountryField";
import {
    FormType,
    UniversityCourseDropDownInterface,
    UserIntakeYear,
    UserPreferredCountry,
    UserPreferredLevel,
} from "../../../containers/RegistrationLoginPage/types";
import FieldWrapper from "./FieldWrapper";
import IntakeYear from "./Fields/IntakeYear";
import PreferredLevel from "./Fields/PreferredLevel";
import UniversityCourseDropDown from "./Fields/UniversityCourseDropDown";
import PreferredCourseWrapper from "./Fields/PreferredCourseWrapper";
import PreferredSpecializationWrapper from "./Fields/PreferredSpecialionWrapper";
import {FormUl} from "./loaderStyled";
import {useSelector} from "react-redux";
import {RootStore} from "../../../configureStore";
import IntakeMonthWrapper from "./Fields/IntakeMonthWrapper";

export interface FutureEducationProps {
    course: UniversityCourseDropDownInterface;
    intakeYear: UserIntakeYear;
    preferredCountry: UserPreferredCountry;
    preferredLevel: UserPreferredLevel;
    formType: FormType;
    showPersonalSection: boolean;
}

const FutureEducation: React.FC<FutureEducationProps> = ({
    course,
    intakeYear,
    preferredCountry,
    preferredLevel,
    formType,
    showPersonalSection,
}: FutureEducationProps) => {
    const isMobile = useSelector((state: RootStore) => state.layout.isMobile);

    return (
        <TabsSection>
            {!isMobile && (
                <>
                    <h2 data-testid="future-heading">
                        {!showPersonalSection ? `1` : `2`}. Future education preference
                    </h2>
                    <span>
                        This will help us show you information related to your course & country of
                        interest.
                    </span>
                </>
            )}
            <TabFormSection>
                <FormUl>
                    {course && (
                        <FieldWrapper visible={course.visible} addEmptyLi={true}>
                            <UniversityCourseDropDown configuration={course} />
                        </FieldWrapper>
                    )}

                    {intakeYear && (
                        <FieldWrapper visible={intakeYear.visible}>
                            <IntakeYear configuration={intakeYear} formType={formType} />
                        </FieldWrapper>
                    )}
                    <IntakeMonthWrapper />
                    {formType === "counsellingEditProfile" && <FormUlList />}
                    {preferredCountry && (
                        <FieldWrapper visible={preferredCountry.visible}>
                            <CountryField configuration={preferredCountry} formType={formType} />
                        </FieldWrapper>
                    )}
                    {preferredLevel && (
                        <FieldWrapper visible={preferredLevel.visible} addEmptyLi={true}>
                            <PreferredLevel configuration={preferredLevel} />
                        </FieldWrapper>
                    )}
                    <PreferredCourseWrapper />
                    <PreferredSpecializationWrapper />
                </FormUl>
            </TabFormSection>
        </TabsSection>
    );
};
export default FutureEducation;
